import React, { useState, Fragment, lazy } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MessageCircle, X } from 'lucide-react';
type Category = 'gran-escala' | 'empresa' | 'hogar';
const categories: {
  id: Category;
  label: string;
  desc: string;
}[] = [{
  id: 'gran-escala',
  label: 'Proyectos a gran escala',
  desc: 'Contamos con la experiencia y el equipo para llevar a cabo construcciones de cualquier magnitud con total seguridad.'
}, {
  id: 'empresa',
  label: 'Tu empresa',
  desc: 'Oficinas, recepciones, auditorios y locales comerciales diseñados para la eficiencia operativa.'
}, {
  id: 'hogar',
  label: 'Tu hogar',
  desc: 'Reformas de alta gama y construcción de vivienda desde cero.'
}];
const projects = [{
  id: 1,
  category: 'gran-escala',
  image: 'https://images.unsplash.com/photo-1541888086425-d81bb19240f5?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  title: 'Infraestructura Vial'
}, {
  id: 2,
  category: 'gran-escala',
  image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1631&q=80',
  title: 'Desarrollo Civil'
}, {
  id: 3,
  category: 'empresa',
  image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1469&q=80',
  title: 'Oficinas Corporativas'
}, {
  id: 4,
  category: 'empresa',
  image: 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  title: 'Espacios Comerciales'
}, {
  id: 5,
  category: 'hogar',
  image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1475&q=80',
  title: 'Reforma Residencial Moderna'
}, {
  id: 6,
  category: 'hogar',
  image: 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  title: 'Diseño de Interiores'
}];
const granEscalaSubcategories = [{
  id: 'puentes',
  title: 'Puentes',
  image: 'https://cdn.magicpatterns.com/uploads/pnoik2t1uik3AYNAyE3KeA/gerfaj-panamericano.jpg',
  gallery: ['https://cdn.magicpatterns.com/uploads/9nPWuiEvfd5SUzDaue91AF/gerfaj_paranamericano_landing.png', 'https://cdn.magicpatterns.com/uploads/vNZKWNaBwrT3XwAazfkxAd/gerfaj_giron_landing.png', 'https://cdn.magicpatterns.com/uploads/cEAGr1PFV5as5c4M8SYnFG/gerfaj_cenfer_LANDING.png']
}, {
  id: 'iglesias',
  title: 'Iglesias',
  image: 'https://cdn.magicpatterns.com/uploads/bCcoAY7krYvPZXDBTFWrXo/GERFAJ-IGLESIA_LA_MESA.jpg',
  gallery: ['https://cdn.magicpatterns.com/uploads/4yk6fQxJardYaxDEePa6dD/gerfaj_la_colina_landing.png', 'https://cdn.magicpatterns.com/uploads/82xZ8M7J6556saH5E8LyZp/gerfaj_zapamanga_landing.png', 'https://cdn.magicpatterns.com/uploads/dEb1A2QhhU6W6tHf5if6iK/GERFAJ_JEFER_LANDING.png']
}, {
  id: 'conventos',
  title: 'Conventos',
  image: 'https://cdn.magicpatterns.com/uploads/eXKSGKTesqTxbYM4qSEnkb/GERFAJ-CONVENTO.jpg',
  gallery: ['https://cdn.magicpatterns.com/uploads/q7qjbenjYPSjdN2KV4CDHC/gerfaj_convento_landing_01.png', 'https://cdn.magicpatterns.com/uploads/eX8cQNxhm4TFqqMbtQ4BM9/gerfaj_convento_landing_02.png', 'https://cdn.magicpatterns.com/uploads/wrRz4PmPJVF5XUBrMsTYJs/gerfaj_convento_landing_03.png']
}, {
  id: 'edificios',
  title: 'Edificios',
  image: 'https://cdn.magicpatterns.com/uploads/3Wdwck5yXpVYi1FuX8pW1Z/gerfaj_-_superior.png',
  gallery: ['https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1479839672679-a46483c0e7c8?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1428366890462-dd4baecf492b?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80']
}, {
  id: 'bodegas',
  title: 'Bodegas',
  image: 'https://cdn.magicpatterns.com/uploads/trVYiPToySmS52td4KV34U/GERFAJ_-_BODEGAS.png',
  gallery: ['https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1565891741441-64926e441838?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1553413077-190dd305871c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80']
}];
const empresaSubcategories = [{
  id: 'auditorios',
  title: 'Auditorios',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  gallery: ['https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1540575467063-178a50c2df87?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1505373877841-8d25f7d46678?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80']
}, {
  id: 'oficinas',
  title: 'Oficinas',
  image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1469&q=80',
  gallery: ['https://images.unsplash.com/photo-1497366216548-37526070297c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1469&q=80', 'https://images.unsplash.com/photo-1524758631624-e2822e304c36?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1604328698692-f76ea9498e76?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80']
}, {
  id: 'recepciones',
  title: 'Recepciones',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  gallery: ['https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1631679706909-1844bbd07221?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80']
}];
const hogarSubcategories = [{
  id: 'reforma-residencial',
  title: 'Reforma residencial',
  image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1475&q=80',
  gallery: ['https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=1475&q=80', 'https://images.unsplash.com/photo-1600607687920-4e2a09cf159d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80']
}, {
  id: 'construccion-desde-cero',
  title: 'Construcción desde cero',
  image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80',
  gallery: ['https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1631679706909-1844bbd07221?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80', 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-4.0.3&auto=format&fit=crop&w=1470&q=80']
}];
const subcategoriesMap: Record<string, typeof granEscalaSubcategories> = {
  'gran-escala': granEscalaSubcategories,
  empresa: empresaSubcategories,
  hogar: hogarSubcategories
};
export function PortfolioSection() {
  const [activeCategory, setActiveCategory] = useState<Category>('gran-escala');
  const [activeSubcategory, setActiveSubcategory] = useState<string | null>(null);
  const handleCategoryChange = (catId: Category) => {
    setActiveCategory(catId);
    setActiveSubcategory(null);
  };
  const filteredProjects = projects.filter(p => p.category === activeCategory);
  const activeCatData = categories.find(c => c.id === activeCategory);
  const currentSubcategories = subcategoriesMap[activeCategory];
  const whatsappUrl = 'https://wa.me/573182434499?text=Hola%20Gerfaj%2C%20vi%20su%20p%C3%A1gina%20de%20Reformas%20y%20quiero%20una%20asesor%C3%ADa%20para%20mi%20proyecto.';
  return <section className="py-24 md:py-32 bg-gerfaj-dark" data-id="element-105">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-106">
        <div className="text-center mb-12" data-id="element-107">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-montserrat font-bold text-white mb-4" data-id="element-108">
            30 años de resultados que{' '}
            <span className="text-gerfaj-orange" data-id="element-109">puedes ver</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-gray-400 text-base md:text-lg max-w-xl mx-auto" data-id="element-110">
            Aplicamos el mismo rigor profesional en cada detalle, sin importar
            la escala.
          </motion.p>
        </div>

        <div className="flex flex-col sm:flex-row justify-center gap-4 mb-8" data-id="element-111">
          {categories.map(cat => <button key={cat.id} onClick={() => handleCategoryChange(cat.id)} className={`px-6 py-4 sm:py-3 rounded-2xl sm:rounded-full text-base font-medium transition-all duration-300 w-full sm:w-auto ${activeCategory === cat.id ? 'bg-gerfaj-blue text-white border border-gerfaj-blue shadow-lg' : 'bg-transparent text-gray-400 border border-gray-700 hover:border-gray-500 hover:text-white'}`} data-id="element-112">
              {cat.label}
            </button>)}
        </div>

        <motion.p key={activeCategory} initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="text-gerfaj-orange font-medium text-base md:text-lg text-center mb-10 min-h-[3rem] flex items-center justify-center" data-id="element-113">
          {activeCatData?.desc}
        </motion.p>

        {currentSubcategories ? <div className="mb-12" data-id="element-114">
            <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 ${currentSubcategories.length === 5 ? 'xl:grid-cols-5' : 'xl:grid-cols-3'} gap-4`} data-id="element-115">
              {currentSubcategories.map((sub, index) => <Fragment key={sub.id} data-id="element-116">
                  <motion.div layout initial={{
              opacity: 0,
              scale: 0.9
            }} animate={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.4,
              delay: index * 0.05
            }} onClick={() => setActiveSubcategory(activeSubcategory === sub.id ? null : sub.id)} className={`group relative aspect-video overflow-hidden rounded-2xl bg-gray-800 cursor-pointer border-2 transition-colors duration-300 ${activeSubcategory === sub.id ? 'border-gerfaj-orange' : 'border-transparent hover:border-gray-600'}`} data-id="element-117">
                    <img src={sub.image} alt={sub.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-60 group-hover:opacity-80" loading="lazy" decoding="async" width={1470} height={980} data-id="element-118" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" data-id="element-119"></div>
                    <div className="absolute bottom-0 left-0 p-4 w-full" data-id="element-120">
                      <h3 className="text-lg md:text-xl font-montserrat font-bold text-white drop-shadow-lg" data-id="element-121">
                        {sub.title}
                      </h3>
                      <div className={`h-1 bg-gerfaj-orange mt-2 rounded-full transition-all duration-300 ${activeSubcategory === sub.id ? 'w-12 opacity-100' : 'w-0 opacity-0 group-hover:w-8 group-hover:opacity-100'}`} data-id="element-122"></div>
                    </div>
                  </motion.div>

                  <AnimatePresence data-id="element-123">
                    {activeSubcategory === sub.id && <motion.div initial={{
                opacity: 0,
                height: 0
              }} animate={{
                opacity: 1,
                height: 'auto'
              }} exit={{
                opacity: 0,
                height: 0
              }} transition={{
                duration: 0.4
              }} className={`overflow-hidden col-span-1 sm:col-span-2 lg:col-span-3 ${currentSubcategories.length === 5 ? 'xl:col-span-5' : 'xl:col-span-3'}`} data-id="element-124">
                        <div className="bg-white/5 border border-white/10 rounded-3xl p-5 md:p-8 relative mt-2" data-id="element-125">
                          <button onClick={e => {
                    e.stopPropagation();
                    setActiveSubcategory(null);
                  }} className="absolute top-4 right-4 p-2 bg-black/20 hover:bg-black/40 rounded-full text-gray-400 hover:text-white transition-colors z-10" data-id="element-126">
                            <X className="w-5 h-5" data-id="element-127" />
                          </button>

                          <h4 className="text-xl md:text-2xl font-montserrat font-bold text-white mb-5 flex items-center gap-3" data-id="element-128">
                            Proyectos de {sub.title}
                            <span className="h-px flex-1 bg-gradient-to-r from-white/10 to-transparent" data-id="element-129"></span>
                          </h4>

                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-130">
                            {sub.gallery.map((img, idx) => <motion.div key={idx} initial={{
                      opacity: 0,
                      y: 20
                    }} animate={{
                      opacity: 1,
                      y: 0
                    }} transition={{
                      delay: idx * 0.1
                    }} className="aspect-video rounded-2xl overflow-hidden bg-gray-800 relative" data-id="element-131">
                                <img src={img} alt={`Proyecto ${sub.title} ${idx + 1}`} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" loading="lazy" decoding="async" width={1470} height={980} data-id="element-132" />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none" data-id="element-133"></div>
                              </motion.div>)}
                          </div>
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </Fragment>)}
            </div>
          </div> : <motion.div layout className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-134">
            <AnimatePresence mode="popLayout" data-id="element-135">
              {filteredProjects.map(project => <motion.div key={project.id} layout initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} exit={{
            opacity: 0,
            scale: 0.9
          }} transition={{
            duration: 0.4
          }} className="group relative aspect-video overflow-hidden rounded-2xl bg-gray-800" data-id="element-136">
                  <img src={project.image} alt={project.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-80 group-hover:opacity-100" loading="lazy" decoding="async" width={1470} height={980} data-id="element-137" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" data-id="element-138"></div>
                  <div className="absolute bottom-0 left-0 p-8 translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-139">
                    <h3 className="text-2xl font-montserrat font-bold text-white drop-shadow-lg" data-id="element-140">
                      {project.title}
                    </h3>
                    <div className="w-12 h-1 bg-gerfaj-orange mt-4 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100" data-id="element-141"></div>
                  </div>
                </motion.div>)}
            </AnimatePresence>
          </motion.div>}

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="flex justify-center" data-id="element-142">
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 bg-gerfaj-orange hover:bg-orange-600 text-white font-bold text-lg px-8 py-4 rounded-2xl cta-glow transition-colors duration-300 w-[90%] sm:w-auto min-h-[60px]" data-id="element-143">
            <MessageCircle className="w-6 h-6" data-id="element-144" />
            Quiero que mi proyecto se vea así
          </a>
        </motion.div>
      </div>
    </section>;
}